import { computed, onMounted } from 'vue'
import { useStore } from 'vuex'
import onTransitionendCallback from 'components/PageOverlay/methods/onTransitionendCallback'

export default {
    name: 'ArticleOverlay',
    setup() {
        const store = useStore()
        const html = computed(() => {
            return store.state.main.article_overlay_data
        })

        onMounted(() => {
            const closeButton = document.querySelector(
                '.kb-page-overlay__close'
            )
            onTransitionendCallback({
                opening() {
                    closeButton.focus()
                }
            })
        })

        return { html }
    }
}
